import { render, staticRenderFns } from "./SendBotOnePlatFormDetail.vue?vue&type=template&id=47dac276&"
import script from "./SendBotOnePlatFormDetail.vue?vue&type=script&lang=js&"
export * from "./SendBotOnePlatFormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports